import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface EmailAIPrompt {
  id: string;
  name: string;
  description: string;
  prompt: string;
  category: 'generate';
}

export interface EmailAIRequest {
  prompt_id: string;
  current_content?: string;
  subject?: string;
  context?: {
    recipient_name?: string;
    recipient_email?: string;
    sender_name?: string;
    sender_email?: string;
    module_type?: string;
    record_name?: string;
  };
}

export interface EmailAIResponse {
  success: boolean;
  content: string;
  subject?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AIEmailService {

  private readonly baseUrl = environment.url + '/ai/email';

  constructor(private http: HttpClient) {}

  /**
   * Get available AI prompts for email generation and refactoring
   */
  getAvailablePrompts(): Observable<EmailAIPrompt[]> {
    return this.http.post<EmailAIPrompt[]>(`${this.baseUrl}/prompts`, {});
  }

    /**
   * Generate email content using AI
   */
  generateEmail(request: EmailAIRequest): Observable<EmailAIResponse> {
    // Add unique elements to ensure varied responses
    const enhancedContext = request.context ? {
      ...request.context,
      timestamp: new Date().toISOString(),
      request_id: Math.random().toString(36).substring(2, 15),
      generation_count: Date.now()
    } : null;

    // Ensure context is properly serialized
    const serializedRequest = {
      ...request,
      context: enhancedContext ? JSON.stringify(enhancedContext) : null
    };

    // Removed console logging to avoid exposing sensitive lead/contact details in the browser console

    return this.http.post<EmailAIResponse>(`${this.baseUrl}/generate`, serializedRequest);
  }


}
